import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DirectSubscriptionService } from '@app/modules/direct/services/direct-subscription.service';
import { Observable, of } from 'rxjs';
import { catchError, ignoreElements, shareReplay } from 'rxjs/operators';
import {
  CancellationPolicy,
  CancellationTermType,
  DirectService,
  PaymentTermStatus,
} from '../../services/direct.service';

@Component({
  standalone: false,
  templateUrl: './direct-booking-policies.component.html',
  styleUrls: ['./direct-booking-policies.component.scss'],
})
export class DirectBookingPoliciesComponent implements OnInit {
  policies$: Observable<CancellationPolicy[]> = this.direct.fetchCancellationPolicies().pipe(shareReplay(1));
  policiesError$: Observable<boolean> = this.policies$.pipe(
    ignoreElements(),
    catchError(() => of(true))
  );
  PaymentTermStatus = PaymentTermStatus;
  CancellationTermType = CancellationTermType;
  isPremium$ = this.directSubsriptionService.isPremium$;

  constructor(
    private direct: DirectService,
    private directSubsriptionService: DirectSubscriptionService,
    private router: Router
  ) { }

  ngOnInit(): void { }

  createNewCancellationPolicy() {
    this.router.navigate(['/direct/booking-policies/new']);
  }
}
